export enum PAYMENT_TYPE {
  RECEIPT = "RECEIPT",
  CARD = "CARD",
  APPLE_GOOGLE_PAY = "APPLE_GOOGLE_PAY",
}
